module.exports = "/_next/static/images/wirelessCom2-4c5b1ddc63d2fff24c7327c7011279af.webp";